import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import CommonSelect from '../../../core/common/commonSelect'
import { label } from 'yet-another-react-lightbox/*'
import { DatePicker } from 'antd'
import CommonTagsInput from '../../../core/common/Taginput'
import CommonTextEditor from '../../../core/common/textEditor'
import CollapseHeader from '../../../core/common/collapse-header/collapse-header'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../core/data/redux/store'
import { capitalizeFirstLetter, downloadContents, getColorForValue, getTimeDifference, groupByDateTime } from '../../../core/data/utils'
import { addCommentAction, fetchTaskDataAction, getTaskAction, updateStatusAction, updateTaskAction } from '../../../core/data/redux/actions/TaskActions'
import Select from 'react-select'
import moment from 'moment'
import MediaUpload from '../../../core/modals/mediaUploader'
import MediaUploadModal from '../../../core/modals/mediaUploadModal'
import TaskCommentsModal from '../../../core/modals/commentModal'
import Modal from "react-bootstrap/Modal";
import Loader from '../../Loader/Loader'
import { formatError, formatSuccess } from '../../../core/data/redux/service/AuthService'
import {
    fetchTaskExternalSubscribers,
    saveTaskExternalSubscribers,
} from '../../../core/data/redux/service/OrgExternalUpdatesService'
const TaskDetails = () => {
    const [loading, setLoading] = useState(true);
    const getModalContainer = () => {
        const modalElement = document.getElementById('modal-datepicker');
        return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
    };
    const [commentText, setCommentText] = useState("");
    const [key, setKey] = useState(0);
    const routes = all_routes;
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const initialTask = { taskId: "", status: null, assignedTo: null };
    const [task, setTask] = useState(initialTask)
    const ticketDetails = useSelector((state: RootState) => state.task.task);
    const { taskId } = useParams();
    const masters = useSelector((state: RootState) => state.admin.masters);
    const [category, setCategory] = useState<any>([]);
    const [users, setUsers] = useState<any>([]);
    const [status, setStatus] = useState<any>([]);
    const [nextStatus, setNextStatus] = useState<any>([]);
    const [priority, setPriority] = useState<any>([]);
    const [selectedFile, setSelectedFile] = useState<any>(null);
    const [showModal, setShowModal] = useState(false);
    const [showCompletedModal, setShowCompletedModal] = useState(false);
    const [externalContacts, setExternalContacts] = useState<{ value: string; label: string }[]>([]);
    const [selectedExternalContacts, setSelectedExternalContacts] = useState<{ value: string; label: string }[]>([]);
    const [savingExternalSubscribers, setSavingExternalSubscribers] = useState(false);
    const openFileInModal = (file: any) => {
        setSelectedFile(file);
        setShowModal(true);
    };
    useEffect(() => {
        console.log(ticketDetails)
    }, [ticketDetails]);
    const closeModal = () => {
        setSelectedFile(null);
        setShowModal(false);
    };
    useEffect(() => {
        if (taskId) {
            dispatch(getTaskAction(taskId));
            setTask((prevdata) => ({ ...prevdata, taskId: taskId }))
            fetchTaskExternalSubscribers(taskId)
                .then((res: any) => {
                    const available = (res.data?.available || []).map((c: any) => ({
                        value: c.id,
                        label: `${c.name} (${c.mobileNumber})`,
                    }));
                    const selected = (res.data?.selected || []).map((c: any) => ({
                        value: c.id,
                        label: `${c.name} (${c.mobileNumber})`,
                    }));
                    setExternalContacts(available);
                    setSelectedExternalContacts(selected);
                })
                .catch(() => {
                    setExternalContacts([]);
                    setSelectedExternalContacts([]);
                });
        }
    }, [taskId]);
    useEffect(() => {
        const closeButton = document.querySelector("#add_files .btn-close") as HTMLButtonElement;
        if (closeButton) {
            closeButton.click();
        }
        const closeCommentButton = document.querySelector("#add_comment .btn-close") as HTMLButtonElement;
        if (closeCommentButton) {
            closeCommentButton.click();
        }
    }, [ticketDetails]);
    useEffect(() => {
        if (ticketDetails.nextStatus) {
            const statuses = ticketDetails.nextStatus?.map((data: any) => ({
                value: data,
                label: data,
            })) || [];
            statuses.push({ value: ticketDetails.status, label: ticketDetails.status })
            setNextStatus([{ value: "", label: "Select" }, ...statuses]);
        }
    }, [ticketDetails.nextStatus]);
    useEffect(() => {
        data()
    }, []);
    const updateTask = () => {
        const existingAssignee = users?.find((data: any) => data.label === ticketDetails?.assignedTo)?.value;
        const existingStatus = status.find((data: any) => data.value == ticketDetails.status)?.value;
        if ((task.assignedTo && task.assignedTo === existingAssignee)
            || (task.status && task.status === existingStatus)) {
            formatError("Nothing to update")
        } else {
            if (task.status && task.status !== existingStatus) {
                checkIfTaskAlreadyComplete();
            }
            dispatch(updateTaskAction(task))
        }
    }
    const data = async () => {
        setLoading(true);
        await dispatch(fetchTaskDataAction());
        setTimeout(
            () => {
                setLoading(false);
            }
            , 2000)

    }
    useEffect(() => {
        if (masters) {
            const categories = masters.taskTypes?.map((data: any) => ({
                value: data,
                label: data,
            })) || [];

            const statuses = masters.taskStatuses?.map((data: any) => ({
                value: data,
                label: data,
            })) || [];

            const priorities = masters.taskPriority?.map((data: any) => ({
                value: data,
                label: data,
            })) || [];

            const userOptions = masters.users?.map((data: any) => ({
                value: data.userName,
                label: data.name,
            })) || [];

            setCategory([{ value: "", label: "Select" }, ...categories]);
            setStatus([{ value: "", label: "Select" }, ...statuses]);
            setPriority([{ value: "", label: "Select" }, ...priorities]);
            setUsers([{ value: "", label: "Select" }, ...userOptions]);
        }
    }, [masters]);
    const handleAddComment = () => {
        if (!commentText.trim()) return;

        setCommentText("");
        dispatch(addCommentAction({ taskId: taskId, remarks: commentText }))
        checkIfTaskAlreadyComplete();
    };
    const handleTaskChange = (name: any, value: any) => {
        switch (name) {
            case "assignedTo":
                if (value !== users.find((data: any) => data.value == value))
                    setTask((prevdata) => ({ ...prevdata, assignedTo: value.value }))
                else
                    setTask((prevdata: any) => ({ ...prevdata, assignedTo: null }))

                break;
            case "status":
                if (value !== status.find((data: any) => data.value == value))
                    setTask((prevdata: any) => ({ ...prevdata, status: value.value }))
                else
                    setTask((prevdata: any) => ({ ...prevdata, status: null }))
                break;
        }
    }
    const checkIfTaskAlreadyComplete = () => {
        if (ticketDetails.isClosed) {
            setShowCompletedModal(true);
        }
    }
    const saveExternalWhatsappSubscribers = () => {
        if (!taskId) return;
        setSavingExternalSubscribers(true);
        saveTaskExternalSubscribers(
            taskId,
            selectedExternalContacts.map(c => c.value),
        )
            .then(() => formatSuccess('External WhatsApp subscribers updated'))
            .catch(err => formatError(err))
            .finally(() => setSavingExternalSubscribers(false));
    }
    return (
        <>
            {loading ?

                (<Loader />) : (
                    <>
                        {/* Page Wrapper */}
                        <div className="page-wrapper">
                            <div className="content">
                                {/* Breadcrumb */}
                                <div className="row align-items-center mb-4">
                                    <div className="d-md-flex d-sm-block justify-content-between align-items-center flex-wrap">
                                        <h6 className="fw-medium d-inline-flex align-items-center mb-3 mb-sm-0">
                                            <Link to={all_routes.tickets}>
                                                <i className="ti ti-arrow-left me-2" />
                                                Back to List
                                            </Link>
                                        </h6>
                                        <div className="d-flex">
                                            {/* <div className="text-end">
                                    <Link
                                        to="#"
                                        className="btn btn-primary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#edit_task"
                                    >
                                        <i className="ti ti-edit me-1" />
                                        Edit Task
                                    </Link>
                                </div> */}
                                            <div className="head-icons ms-2 text-end">
                                                <CollapseHeader />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* /Breadcrumb */}
                                <div className="row">
                                    <div className="col-xl-8">
                                        <div className="card">
                                            <div className="card-body pb-1">
                                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4">
                                                    <div>
                                                        <h4 className="mb-1">
                                                            {capitalizeFirstLetter(ticketDetails.title)}
                                                        </h4>
                                                        <p>
                                                            Priority :{" "}
                                                            <span className={`badge ${getColorForValue(ticketDetails.priority)} d-inline-flex align-items-center me-3`}>
                                                                <i className="ti ti-circle-filled fs-5 me-1" />
                                                                {ticketDetails.priority}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row align-items-center">
                                                    <div className="col-sm-12">
                                                        <div className="mb-3">
                                                            <h6 className="mb-1">Description</h6>
                                                            <p>
                                                                {ticketDetails.description}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-3">
                                                        <p className="d-flex align-items-center mb-3">
                                                            <i className="ti ti-user-shield me-2" />
                                                            Assignee
                                                        </p>
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <div className="d-flex align-items-center mb-3">
                                                            <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                                                                <Link
                                                                    to="#"
                                                                    className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                                                                >
                                                                    {ticketDetails.assignedToImage ?
                                                                        <img
                                                                            src={`data:image/png;base64,${ticketDetails.assignedToImage}`}
                                                                            className="avatar avatar-xs rounded-circle me-2"
                                                                            alt="img"
                                                                        /> :
                                                                        <ImageWithBasePath
                                                                            src="assets/img/profiles/avatar-12.jpg"
                                                                            className="avatar avatar-xs rounded-circle me-2"
                                                                            alt="img"
                                                                        />}
                                                                </Link>
                                                                <h6 className="fs-12">
                                                                    <Link to="#">{capitalizeFirstLetter(ticketDetails.assignedTo)}</Link>
                                                                </h6>
                                                            </div>
                                                            {/* <div>
                                                    <Link to="#" className="d-flex align-items-center fs-12">
                                                        <i className="ti ti-circle-plus me-1" />
                                                        Add New
                                                    </Link>
                                                </div> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-3">
                                                        <p className="d-flex align-items-center mb-3">
                                                            <i className="ti ti-user-shield me-2" />
                                                            Author
                                                        </p>
                                                    </div>
                                                    <div className="col-sm-9">
                                                        <div className="d-flex align-items-center mb-3">
                                                            <div className="bg-gray-100 p-1 rounded d-flex align-items-center me-2">
                                                                <Link
                                                                    to="#"
                                                                    className="avatar avatar-sm avatar-rounded border border-white flex-shrink-0 me-2"
                                                                >
                                                                    {ticketDetails.assignedByImage ?
                                                                        <img
                                                                            src={`data:image/png;base64,${ticketDetails.assignedByImage}`}
                                                                            className="avatar avatar-xs rounded-circle me-2"
                                                                            alt="img"
                                                                        /> :
                                                                        <ImageWithBasePath
                                                                            src="assets/img/profiles/avatar-12.jpg"
                                                                            className="avatar avatar-xs rounded-circle me-2"
                                                                            alt="img"
                                                                        />}
                                                                </Link>
                                                                <h6 className="fs-12">
                                                                    <Link to="#">{capitalizeFirstLetter(ticketDetails.assignedBy)}</Link>
                                                                </h6>
                                                            </div>
                                                            {/* <div>
                                                    <Link to="#" className="d-flex align-items-center fs-12">
                                                        <i className="ti ti-circle-plus me-1" />
                                                        Add New
                                                    </Link>
                                                </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="custom-accordion-items">
                                            <div className="accordion accordions-items-seperate">
                                                <div className="accordion-item">
                                                    <div className="accordion-header" id="headingFour">
                                                        <div className="accordion-button">
                                                            <div className="d-flex align-items-center flex-fill">
                                                                <h5>Files</h5>
                                                                <div className=" ms-auto d-flex align-items-center">
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-primary btn-sm d-inline-flex align-items-center me-3"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#add_files"
                                                                    >
                                                                        <i className="ti ti-square-rounded-plus-filled me-1" />
                                                                        Add New
                                                                    </Link>
                                                                    <Link
                                                                        to="#"
                                                                        className="d-flex align-items-center collapse-arrow"
                                                                        data-bs-toggle="collapse"
                                                                        data-bs-target="#primaryBorderFour"
                                                                        aria-expanded="true"
                                                                        aria-controls="primaryBorderFour"
                                                                    >
                                                                        <i className="ti ti-chevron-down fs-18" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="primaryBorderFour"
                                                        className="accordion-collapse collapse show border-top"
                                                        aria-labelledby="headingFour"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="files-carousel owl-carousel">
                                                                {ticketDetails.taskFiles &&
                                                                    ticketDetails.taskFiles.map((file: any, index: number) => {
                                                                        const fileName = file.type + "." + file.name.split(".")[1];
                                                                        const fileSizeInBytes = atob(file.data || "").length;
                                                                        const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2);
                                                                        const fileIcon =
                                                                            file.type.toLowerCase() === "document"
                                                                                ? "assets/img/icons/file-02.svg"
                                                                                : file.type.toLowerCase() === "video"
                                                                                    ? "assets/img/icons/video.svg"
                                                                                    : file.type.toLowerCase() === "image"
                                                                                        ? "assets/img/icons/file-03.svg"
                                                                                        : file.type.toLowerCase() === "audio"
                                                                                            ? "assets/img/icons/voice.svg"
                                                                                            : "assets/img/icons/file.svg";
                                                                        return (
                                                                            <div className="card shadow-none mb-0" key={index}>
                                                                                <div className="card-body">
                                                                                    <div className="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
                                                                                        <div className="d-flex align-items-center overflow-hidden">
                                                                                            <Link to="#" className="avatar avatar-md bg-light me-2">
                                                                                                <ImageWithBasePath
                                                                                                    src={fileIcon}
                                                                                                    className="w-auto h-auto"
                                                                                                    alt="img"
                                                                                                />
                                                                                            </Link>
                                                                                            <div className="overflow-hidden">
                                                                                                <h6 className="mb-1 text-truncate">
                                                                                                    {fileName}
                                                                                                </h6>
                                                                                                <span>{fileSizeInMB} MB</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <Link to="#" className="btn btn-sm btn-icon" onClick={() => downloadContents(file)}>
                                                                                                <i className="ti ti-download" />
                                                                                            </Link>
                                                                                            <Link to="#" className="btn btn-sm btn-icon" onClick={() => openFileInModal(file)}>
                                                                                                <i className="ti ti-eye" /> {/* Eye icon for preview */}
                                                                                            </Link>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                                        <p className="fw-medium mb-0">
                                                                                            {moment(file.uploadedAt).format("DD MMM YYYY, hh:mm A")}
                                                                                        </p>
                                                                                        <span className='float-right'>{capitalizeFirstLetter(file.uploadedBy)}</span>
                                                                                        {/* <span className="avatar avatar-sm avatar-rounded">
                                                                                <ImageWithBasePath
                                                                                    src="assets/img/profiles/avatar-02.jpg"
                                                                                    alt="Img"
                                                                                /> 
                                                                            </span>*/}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="accordion accordions-items-seperate">
                                                <div className="accordion-item">
                                                    <div className="accordion-header" id="headingComments">
                                                        <div className="accordion-button">
                                                            <div className="d-flex align-items-center flex-fill">
                                                                <h5>Comments</h5>
                                                                <div className=" ms-auto d-flex align-items-center">
                                                                    <Link
                                                                        to="#"
                                                                        className="btn btn-primary btn-sm d-inline-flex align-items-center me-3"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#add_comment"
                                                                    >
                                                                        <i className="ti ti-square-rounded-plus-filled me-1" />
                                                                        Add New
                                                                    </Link>
                                                                    <Link
                                                                        to="#"
                                                                        className="d-flex align-items-center collapse-arrow"
                                                                        aria-expanded="true"
                                                                        aria-controls="primaryBorderComments"
                                                                    >
                                                                        <i className="ti ti-chevron-down fs-18" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {ticketDetails.comments && <div
                                                        id="primaryBorderComments"
                                                        className="accordion-collapse collapse show border-top"
                                                        aria-labelledby="headingComments"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="files-carousel owl-carousel">
                                                                {ticketDetails.comments.map((comment: any, index: number) => (
                                                                    <div style={{ border: '1px dotted', borderRadius: '0.6rem' }}>
                                                                        <div className="d-flex align-items-center mb-3" style={{ borderBottom: '0.5px solid #e9e9e9' }}>
                                                                            <span className="avatar avatar-ld avatar-rounded me-2 flex-shrink-0">
                                                                                {comment.imagePath ?
                                                                                    <img
                                                                                        src={`data:image/png;base64,${comment.imagePath}`}
                                                                                        className="avatar avatar-xs rounded-circle me-2"
                                                                                        alt="img"
                                                                                    /> :
                                                                                    <ImageWithBasePath
                                                                                        src="assets/img/profiles/avatar-12.jpg"
                                                                                        className="avatar avatar-xs rounded-circle me-2"
                                                                                        alt="img"
                                                                                    />}
                                                                            </span>
                                                                            <div>
                                                                                <h6 className="mb-1">{comment.userName}</h6>
                                                                                <p>
                                                                                    <i className="ti ti-calendar-bolt me-1" />
                                                                                    Updated {getTimeDifference(comment.createdOn)}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <div className="m-3">
                                                                                <p>
                                                                                    {comment.comment}
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    <hr />
                                                    <div className="mx-3">
                                                        <textarea
                                                            className="form-control"
                                                            id="commentText"
                                                            rows={3}
                                                            placeholder="Write your comment here..."
                                                            value={commentText}
                                                            onChange={(e) => setCommentText(e.target.value)}
                                                        ></textarea>
                                                        <button type="button" className="btn btn-primary m-2 text-center" onClick={handleAddComment}>Submit</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-4">
                                        <div className="card">
                                            <div className="card-body p-0">
                                                <div className="d-flex flex-column">
                                                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                                                        <p className="mb-0">Department</p>
                                                        <h6 className="fw-normal">{ticketDetails.taskType}</h6>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                                                        <p className="mb-0">Status</p>
                                                        <Select
                                                            name='status'
                                                            id='status'
                                                            className="react-select"
                                                            options={nextStatus}
                                                            value={task.status ? nextStatus?.find((option: any) => option.value === task.status) : nextStatus?.find((option: any) => option.value === ticketDetails.status) || nextStatus[0]}
                                                            placeholder="Select"
                                                            // onChange={(value: any) =>
                                                            //     dispatch(updateStatusAction(
                                                            //         { taskId: ticketDetails.id, status: value.value }
                                                            //     ))
                                                            // }
                                                            onChange={(value: any) => handleTaskChange('status', value)}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                                                        <p className="mb-0">Priority</p>
                                                        <h6 className="fw-normal">{ticketDetails.priority}</h6>
                                                        {/* <Select
                                                name='priority'
                                                id='priority'
                                                className="react-select"
                                                options={priority}
                                                value={priority?.find((option:any) => option.value === ticketDetails.priority) || status[0]}
                                                placeholder="Select"
                                                onChange={(handleSelectchange)}
                                            /> */}
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                                                        <p className="mb-0">Assignee</p>
                                                        <Select
                                                            name='priority'
                                                            id='priority'
                                                            className="react-select"
                                                            options={users}
                                                            value={task.assignedTo ? users?.find((option: any) => option.value === task.assignedTo) : users?.find((option: any) => option.label === ticketDetails.assignedTo) || users[0]}
                                                            placeholder="Select"
                                                            onChange={(value: any) => handleTaskChange('assignedTo', value)}
                                                        />
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between border-bottom p-3">
                                                        <p className="mb-0">Created on</p>
                                                        <h6 className="fw-normal">{moment(ticketDetails.createdOn).format("DD MMM YYYY")}</h6>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between p-3">
                                                        <p className="mb-0">Due Date</p>
                                                        <h6 className="fw-normal">{moment(ticketDetails.dueDate).format("DD MMM YYYY")}</h6>
                                                    </div>
                                                    {ticketDetails.reminderCron && <div className="d-flex align-items-center justify-content-between p-3">
                                                        <p className="mb-0">Reminder</p>
                                                        <h6 className="fw-normal">{ticketDetails.reminderCron.split(" ")[1] + " " + ticketDetails.reminderCron.split(" ")[0]}</h6>
                                                    </div>}
                                                    <div className="d-flex align-items-center justify-content-between p-3">
                                                        <p className="mb-0">Is Task repeated?</p>
                                                        <h6 className="fw-normal">{ticketDetails.isRepeated ? "Yes" : "No"}</h6>
                                                    </div>
                                                    {((task.assignedTo && task.assignedTo !== users.find((data: any) => data.label === ticketDetails.assignedTo)?.value)
                                                        || (task.status && task.status !== status.find((data: any) => data.value === ticketDetails.status)?.value))
                                                        && <div className="text-center mb-3">
                                                            <button className='btn btn-success' onClick={() => updateTask()}>Submit</button>
                                                        </div>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="mb-2">External WhatsApp updates</h5>
                                                <p className="text-muted fs-12 mb-2">
                                                    Status changes notify only the selected external contacts.
                                                </p>
                                                {externalContacts.length === 0 ? (
                                                    <p className="text-muted mb-0 fs-12">
                                                        No active external contacts. Add them under Organisation → External WhatsApp.
                                                    </p>
                                                ) : (
                                                    <>
                                                        <Select
                                                            isMulti
                                                            className="react-select mb-2"
                                                            options={externalContacts}
                                                            value={selectedExternalContacts}
                                                            onChange={(value: any) => setSelectedExternalContacts(value || [])}
                                                            placeholder="Select contacts"
                                                        />
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-primary"
                                                            disabled={savingExternalSubscribers}
                                                            onClick={saveExternalWhatsappSubscribers}
                                                        >
                                                            {savingExternalSubscribers ? 'Saving…' : 'Save subscribers'}
                                                        </button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className="custom-accordion-items">
                                            <div className="accordion accordions-items-seperate">
                                                <div className="accordion-item flex-fill">
                                                    <div className="accordion-header" id="headingSix">
                                                        <div className="accordion-button">
                                                            <div className="d-flex align-items-center flex-fill">
                                                                <h5>Activity</h5>
                                                                <div className="d-flex align-items-center ms-auto">
                                                                    <Link
                                                                        to="#"
                                                                        className="d-flex align-items-center collapse-arrow"
                                                                        data-bs-toggle="collapse"
                                                                        data-bs-target="#primaryBorderSix"
                                                                        aria-expanded="true"
                                                                        aria-controls="primaryBorderSix"
                                                                    >
                                                                        <i className="ti ti-chevron-down fs-18" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="primaryBorderSix"
                                                        className="accordion-collapse collapse show border-top"
                                                        aria-labelledby="headingSix"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="notice-widget">
                                                                {ticketDetails.taskActivity &&
                                                                    ticketDetails.taskActivity.map((activity: any, index: number) => {
                                                                        return <div className="d-flex align-items-center justify-content-between mb-4">
                                                                            <div className="d-flex overflow-hidden">
                                                                                <span className={`${activity.actionTaken.toLowerCase() === "created"
                                                                                    ? "bg-success"
                                                                                    : activity.actionTaken.toLowerCase() === "status_change"
                                                                                        ? "bg-warning"
                                                                                        : activity.actionTaken.toLowerCase() === "comment"
                                                                                            ? "bg-secondary"
                                                                                            : activity.actionTaken.toLowerCase() === "file_upload"
                                                                                                ? "bg-primary"
                                                                                                : activity.actionTaken.toLowerCase() === "assignee_change"
                                                                                                    ? "bg-danger"
                                                                                                    : "bg-info"
                                                                                    } avatar avatar-md me-3 rounded-circle flex-shrink-0`}>
                                                                                    <i className={`ti ${activity.actionTaken.toLowerCase() === "created"
                                                                                        ? "ti-checkup-list fs-16"
                                                                                        : activity.actionTaken.toLowerCase() === "status_change"
                                                                                            ? "ti-circle-dot fs-16"
                                                                                            : activity.actionTaken.toLowerCase() === "comment"
                                                                                                ? "ti-point-filled me-1"
                                                                                                : activity.actionTaken.toLowerCase() === "file_upload"
                                                                                                    ? "ti-photo fs-16"
                                                                                                    : activity.actionTaken.toLowerCase() === "assignee_change"
                                                                                                        ? "ti-user fs-16"
                                                                                                        : ""
                                                                                        }`} />
                                                                                </span>
                                                                                <div className="overflow-hidden">
                                                                                    <p className="mb-1">
                                                                                        {/* <span className="text-gray-9 fw-medium">
                                                                                Andrew
                                                                            </span>
                                                                            added a New Task */}
                                                                                        {activity.actionTaken.toLowerCase() == "created" ? <> <span className="text-primary fw-bolder">{capitalizeFirstLetter(activity.actionTakenBy)}</span> added a new task and assigned to <strong className="text-success">{capitalizeFirstLetter(activity.assignedTo)}</strong></>
                                                                                            : activity.actionTaken.toLowerCase() == "status_change" ? <><span className="text-primary fw-bolder">{capitalizeFirstLetter(activity.actionTakenBy)}</span> moved task from <strong className="text-danger">{activity.oldValue}</strong> to <strong className="text-success">{activity.newValue}</strong></>
                                                                                                : activity.actionTaken.toLowerCase() == "comment" ? <><span className="text-primary fw-bolder">{capitalizeFirstLetter(activity.actionTakenBy)}</span> added comment <strong className="text-secondary">{activity.newValue}</strong>.</>
                                                                                                    : activity.actionTaken.toLowerCase() == "file_upload" ? <> <span className="text-primary fw-bolder">{capitalizeFirstLetter(activity.actionTakenBy)}</span> uploaded file(s).</>
                                                                                                        : activity.actionTaken.toLowerCase() == "assignee_change" ? <> <span className="text-primary fw-bolder">{capitalizeFirstLetter(activity.actionTakenBy)}</span> assigned this task from <strong className="text-danger">{activity.oldValue}</strong> to <strong className="text-success">{activity.newValue}</strong>.</>
                                                                                                            : <></>}
                                                                                    </p>
                                                                                    <p className="mb-1">{moment(activity.actionTakenAt).format("DD MMM YYYY hh:mm A")}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                                <p className="mb-0">2025 © HKCL.</p>
                                <p>
                                    Designed &amp; Developed By{" "}
                                    <Link to="https://hkcl.in" target="_blank" className="text-primary">
                                        HKCL
                                    </Link>
                                </p>
                            </div>
                        </div>
                        {/* /Page Wrapper */}

                        {/* Edit Task */}
                        <div className="modal fade" id="edit_task">
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Edit Task</h4>
                                        <button
                                            type="button"
                                            className="btn-close custom-btn-close"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                        >
                                            <i className="ti ti-x" />
                                        </button>
                                    </div>
                                    <form action={all_routes.tickets}>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Title</label>
                                                        <input type="text" className="form-control" value="Patient appointment booking" />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Due Date</label>
                                                        <div className="input-icon-end position-relative">
                                                            <DatePicker
                                                                className="form-control datetimepicker"
                                                                format={{
                                                                    format: "DD-MM-YYYY",
                                                                    type: "mask",
                                                                }}
                                                                getPopupContainer={getModalContainer}
                                                                placeholder="DD-MM-YYYY"
                                                            />
                                                            <span className="input-icon-addon">
                                                                <i className="ti ti-calendar text-gray-7" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Project</label>
                                                        <Select
                                                            className="react-select"
                                                            options={category}
                                                            defaultValue={ticketDetails.taskType || category[0]}
                                                            placeholder="Select"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Status</label>
                                                        <Select
                                                            className="react-select"
                                                            options={status}
                                                            defaultValue={ticketDetails.status || status[0]}
                                                            placeholder="Select"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Priority</label>
                                                        <Select
                                                            className="react-select"
                                                            options={priority}
                                                            defaultValue={ticketDetails.priority || priority[0]}
                                                            placeholder="Select"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">Change Assignee</label>
                                                        <Select
                                                            className="react-select"
                                                            options={users}
                                                            defaultValue={ticketDetails.assignedTo || users[0]}
                                                            placeholder="Select"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="form-label">Who Can See this Task?</label>
                                                    <div className="d-flex align-items-center mb-3">
                                                        <div className="form-check me-3">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault1"
                                                            />
                                                            <label
                                                                className="form-check-label text-dark"
                                                                htmlFor="flexRadioDefault1"
                                                            >
                                                                Public
                                                            </label>
                                                        </div>
                                                        <div className="form-check me-3">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault2"
                                                                defaultChecked
                                                            />
                                                            <label
                                                                className="form-check-label text-dark"
                                                                htmlFor="flexRadioDefault2"
                                                            >
                                                                Private
                                                            </label>
                                                        </div>
                                                        <div className="form-check ">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault3"
                                                                defaultChecked
                                                            />
                                                            <label
                                                                className="form-check-label text-dark"
                                                                htmlFor="flexRadioDefault3"
                                                            >
                                                                Admin Only
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="mb-3">
                                                        <label className="form-label">Descriptions</label>
                                                        <div className="summernote" />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="form-label">Upload Attachment</label>
                                                    <div className="bg-light rounded p-2">
                                                        <div className="profile-uploader border-bottom mb-2 pb-2">
                                                            <div className="drag-upload-btn btn btn-sm btn-white border px-3">
                                                                Select File
                                                                <input
                                                                    type="file"
                                                                    className="form-control image-sign"
                                                                    multiple
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between border-bottom mb-2 pb-2">
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="fs-12 fw-medium me-1">Logo.zip</h6>
                                                                <span className="badge badge-soft-info">21MB </span>
                                                            </div>
                                                            <Link to="#" className="btn btn-sm btn-icon">
                                                                <i className="ti ti-trash" />
                                                            </Link>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <div className="d-flex align-items-center">
                                                                <h6 className="fs-12 fw-medium me-1">Files.zip</h6>
                                                                <span className="badge badge-soft-info">25MB </span>
                                                            </div>
                                                            <Link to="#" className="btn btn-sm btn-icon">
                                                                <i className="ti ti-trash" />
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-light me-2"
                                                data-bs-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            <button type="button" data-bs-dismiss="modal" className="btn btn-primary">
                                                Save
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        {/* /Edit Task */}
                        <MediaUploadModal task={ticketDetails} />
                        <TaskCommentsModal taskId={taskId} />

                        <Modal show={showModal} onHide={closeModal} size="lg" centered>
                            <Modal.Header closeButton>
                                <Modal.Title>File Preview</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="text-center">
                                {selectedFile && selectedFile.type.toLowerCase() === "image" ? (
                                    <img
                                        src={`data:image/*;base64,${selectedFile.data}`}
                                        alt="Preview"
                                        className="img-fluid"
                                        style={{ height: "70vh" }}
                                    />
                                ) : selectedFile && selectedFile.type.toLowerCase() === "video" ? (
                                    <video controls className="w-100" style={{ height: "70vh" }}>

                                        <source
                                            src={`data:video/${selectedFile.name.split(".").pop()};base64,${selectedFile.data}`}
                                            type={`video/${selectedFile.name.split(".").pop()}`}
                                        />
                                        Your browser does not support the video tag.
                                    </video>
                                ) : selectedFile && selectedFile.type.toLowerCase() === "audio" ? (
                                    <audio controls className="w-100">
                                        <source
                                            src={`data:audio/${selectedFile.name.split(".").pop()};base64,${selectedFile.data}`}
                                            type={`audio/${selectedFile.name.split(".").pop()}`}
                                        />
                                        Your browser does not support the audio tag.
                                    </audio>
                                ) : selectedFile && selectedFile.type.toLowerCase() === "document" && selectedFile.name.toLowerCase().endsWith(".pdf") ? (
                                    <iframe
                                        src={`data:application/pdf;base64,${selectedFile.data}#toolbar=0&navpanes=0&scrollbar=0`}
                                        className="w-100"
                                        style={{ height: "70vh", border: "none" }}
                                    />
                                ) : (
                                    <p>File format not supported for preview. Please download and view.</p>
                                )}
                            </Modal.Body>
                        </Modal>
                        <Modal show={showCompletedModal} onHide={() => { setShowCompletedModal(false); setTask(initialTask) }} centered backdrop="static">
                            <Modal.Header closeButton>
                                <Modal.Title>The task has already been marked closed by {ticketDetails.assignedTo} </Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="text-center">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="form-label">Change Assignee?</label>
                                    </div>
                                    <div className="col-md-6">
                                        <Select
                                            name='priority'
                                            id='priority'
                                            className="react-select"
                                            options={users}
                                            value={task.assignedTo ? users?.find((option: any) => option.value === task.assignedTo) : users?.find((option: any) => option.label === ticketDetails.assignedTo) || users[0]}
                                            placeholder="Select"
                                            onChange={(value: any) => handleTaskChange('assignedTo', value)}
                                        />
                                    </div>
                                </div>

                            </Modal.Body>
                            <div className="d-flex justify-content-around p-3 ">
                                <button type="button" className="btn btn-primary" onClick={() => { setShowCompletedModal(false); setTask(initialTask) }}>No</button>
                                {((task.assignedTo && task.assignedTo !== users.find((data: any) => data.label === ticketDetails.assignedTo)?.value)
                                    || (task.status && task.status !== status.find((data: any) => data.value === ticketDetails.status)?.value))
                                    && <button className='btn btn-success' onClick={() => updateTask()}>Submit</button>}
                            </div>
                        </Modal>
                    </>
                )}
        </>

    )
}

export default TaskDetails
